import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { GiftCategory } from "../../types/modules/admin/giftCategory.type";
import { GiftTemplate } from "../../types/modules/admin/giftTemplate.type";

export const useGiftCategoriesByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["gift-categories-by-admin"],
    queryFn: () => fetcher<GiftCategory[]>(`gift-category/admin/all`, token),
  });
};

interface UseParams {
  page?: number;
  limit?: number;
}

export const useGiftTemplatesByAdmin = (
  categoryId: number,
  { page = 1, limit = 10 }: UseParams
) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  return useQuery({
    queryKey: ["gift-tepmpaltes-bycatgeory-by-admin", categoryId],
    queryFn: () =>
      fetcher<{ data: GiftTemplate[]; total: number; totalPages: number }>(
        `gift-template/admin/by-category/${categoryId}?${queryParams}`,
        token
      ),
  });
};
